import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type {
  PostUserOtpUpdateRequestType,
  PostUserOtpUpdateResponseType,
} from '../types';

export const postUserOtpUpdate = async ({
  bodyParams: { identifier, setupPassword },
}: PostUserOtpUpdateRequestType) => {
  const url = '/api/v2/auth/user/otp/update';

  const { data } = await apiAuthClient.post<PostUserOtpUpdateResponseType>(
    url,
    {
      identifier,
      setupPassword,
    },
  );

  return data.data;
};
